import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
   return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      if (value.length === 0) {
         return null;
      }
      const hasLeadingWhitespace = value !== value.trimStart();
      const hasTrailingWhitespace = value !== value.trimEnd();
      const isEmptyAfterTrimming = value.trim().length === 0;
      return hasLeadingWhitespace || hasTrailingWhitespace || isEmptyAfterTrimming ? { whitespace: true } : null;
   };
}
